<div class="d-flex justify-content-between align-items-center">
  <h1>{{'own_properties.your_homes' | translate}}</h1>
  <button class="btn apply" (click)="addProperty()">{{'own_properties.add_property' | translate}}</button>
</div>
<section>
  <app-own-property-list></app-own-property-list>
</section>
